import { useEffect, useReducer, useState } from "react";
import AppRoutes from "./routes/AppRoutes";
import CinematicLoader from "./components/CinematicLoader";
import { AuthContext, AuthReducer, initialState } from "./contexts/Auth/Auth.Context";
import { REACT_APP_SESSION_DATA, REACT_APP_ACCOUNT_DATA } from "./constants";
import axios from "./utils/axios";
import { ThemeProvider, useTheme } from "./components/theme-provider";
import { Center, ColorScheme, ColorSchemeProvider, createEmotionCache, Loader, MantineProvider } from '@mantine/core';
import { useLocalStorage } from "@mantine/hooks";
import { Toaster } from "./components/ui/toaster";

function App() {
  const [state, dispatch] = useReducer(AuthReducer, initialState);

  const [userSession, ] = useState(localStorage.getItem(REACT_APP_SESSION_DATA));

  useEffect(() => {
    const bootstrapAsync = async () => {
      let userToken = userSession;
      let data = null;

      try {
        const cached = localStorage.getItem(REACT_APP_ACCOUNT_DATA);
        if (cached) data = JSON.parse(cached);
      } catch { /* ignore corrupt cache */ }

      if (userToken) {
        try {
          const {
            data: {
              data: accountData,
              token: accessToken
            }
          } = await axios.get("/users/login-with-token", {
            headers: {
              'Authorization': `Bearer ${userToken}`,
              'Content-Type': 'application/json',
            }
          });

          userToken = accessToken;
          data = accountData;
          if (accountData) localStorage.setItem(REACT_APP_ACCOUNT_DATA, JSON.stringify(accountData));
        } catch (error) {
          console.log(error);
          userToken = null;
          data = null;
        }
      }

      dispatch({ type: "RESTORE_TOKEN", token: userToken, data: data });
    };

    bootstrapAsync();

  }, [userSession]);

  const LoaderPage = () => <CinematicLoader />;

  const [colorScheme, setColorScheme] = useLocalStorage<ColorScheme>({
    key: 'color-scheme',
    defaultValue: 'light', // 'light' or 'dark'
    getInitialValueInEffect: true,
  });

  const [dir] = useState("ltr");

  const toggleColorScheme = (value?:ColorScheme) => {
    const nextColorScheme = value || (colorScheme === 'dark' ? 'light' : 'dark');
    setColorScheme(nextColorScheme);
  };

  const myCache = createEmotionCache({ key: "wits-platform"});

  return (
    <ColorSchemeProvider colorScheme={colorScheme} toggleColorScheme={toggleColorScheme}>
    <MantineProvider
    withGlobalStyles
    withNormalizeCSS
    theme={{
      colorScheme,
      primaryColor: "green",
      primaryShade: 9,
      cursorType: "pointer", 
    }}
    emotionCache={myCache}
  >
    <ThemeProvider defaultTheme={useTheme().theme} storageKey="vite-ui-theme">
      <AuthContext.Provider value={{ state, dispatch}}>
        {state.isLoading ? (
          <LoaderPage />
        ) : (
          <AppRoutes />
        )}
        <Toaster />
      </AuthContext.Provider>
    </ThemeProvider>
    </MantineProvider>
    </ColorSchemeProvider>
  );
}

export default App;
